import {ActionButton, DetailsList, FontSizes, FontWeights, IconButton, SelectionMode, Stack} from "@fluentui/react";
import * as React from "react";
import {useContext, useState} from "react";
import AuthContext from "../Services/AuthContext";
import {useParams} from "react-router-dom";
import AddProjectCounter from "../Panel/ProjectCounter/AddProjectCounter";
import EditProjectCounter from "../Panel/ProjectCounter/EditProjectCounter";
import {MoneyFormat} from "../Utilities/MoneyFormat";

function ProjectCounter(props) {
    const [user] = useContext(AuthContext);
    const params = useParams();
    const [addCounter, setAddCounter] = useState(false);
    const [editCounter, setEditCounter] = useState(false);

    const columns = [
        {
            key: 'name',
            name: 'Licznik',
            ariaLabel: 'Licznik',
            fieldName: 'name',
            minWidth: 150,
            isResizable: true,
            isRowHeader: true,
        },
        {
            key: 'number',
            name: 'Numer',
            ariaLabel: 'Numer',
            fieldName: 'numer',
            minWidth: 150,
            isResizable: true,
        },
        {
            key: 'value',
            name: 'Wartość',
            ariaLabel: 'Wartość',
            fieldName: 'value',
            minWidth: 120,
            isResizable: true,
            onRender: (item) => (<span>{MoneyFormat(item.value)}</span>)
        },
        {
            key: 'id',
            name: 'Akcje',
            ariaLabel: 'Akcje',
            fieldName: 'id',
            minWidth: 80,
            isResizable: true,
            onRender: (item) => (<span>
                <IconButton iconProps={ {iconName: 'edit' }} title='Edytuj' onClick={() => setEditCounter(item)}/>
                <IconButton iconProps={ {iconName: 'trash' }} title='Usuń' onClick={() => _delete(item)}/>
            </span>)
        }
    ];
    const addButton = (<ActionButton iconProps={{iconName: 'Add'}} onClick={() => setAddCounter(params.id)}>Dodaj Licznik</ActionButton>)
    const _delete = (item) => {
        fetch(`/api/project/${params.id}/counter/${item.id}`, {
            method: 'DELETE',
            headers: {
                'Authorization': 'Bearer ' + user.token
            }
        }).then(res => res.json())
            .then(json => { props.refresh(); })
            .catch(err => { console.log(err) })
    }

    if (props.data.length) {
        return (<Stack.Item>
            <h2 style={{fontSize: FontSizes.size24, fontWeight: FontWeights.light}}>
                Liczniki
            </h2>
            {addButton}
            <DetailsList items={props.data} columns={columns} selectionMode={SelectionMode.none}/>
            <AddProjectCounter add={addCounter} dismissPanel={() => setAddCounter(false)} onSuccess={props.refresh}/>
            <EditProjectCounter edit={editCounter} dismissPanel={() => setEditCounter(false)} onSuccess={props.refresh}/>
        </Stack.Item>);
    }
    return (<Stack.Item>
            {addButton}
        <AddProjectCounter add={addCounter} dismissPanel={() => setAddCounter(false)} onSuccess={props.refresh}/>
        <EditProjectCounter edit={editCounter} dismissPanel={() => setEditCounter(false)} onSuccess={props.refresh}/>
    </Stack.Item>);
}

export default ProjectCounter;